import { c as _c } from "react/compiler-runtime";
function PickUserList(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ul className="flex flex-wrap">{children}</ul>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default PickUserList;